import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import TextInput from '../../components/TextInput';
import TextAreaInput from '../../components/TextAreaInput';
import FileInput from '../../components/FileInput';
import CheckboxInput from '../../components/CheckboxInput';
import Button from '../../components/Button';
import SkeletonLoader from '../../components/SkeletonLoader';
import testimonialApi from '../../api/testimonialApi';
import { useToast } from '../../contexts/ToastContext';
import { ROUTES } from '../../constants';

const AddTestimonial = () => {
  const navigate = useNavigate();
  const { addToast } = useToast();
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [formData, setFormData] = useState({
    name: '',
    client_designation: '',
    content: '',
    image: '',
    is_active: 1,
  });

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? (checked ? 1 : 0) : (type === 'file' ? files[0] : value),
    });
    if (validationErrors[name]) {
      setValidationErrors(prev => ({ ...prev, [name]: undefined }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setValidationErrors({});

    const data = new FormData();
    for (const key in formData) {
      data.append(key, formData[key]);
    }

    try {
      await testimonialApi.createTestimonial(data);
      addToast('Testimonial created successfully!', 'success');
      navigate(ROUTES.TESTIMONIALS);
    } catch (err) {
      console.error('Failed to add testimonial:', err);
      if (err.response && err.response.status === 422) {
        setValidationErrors(err.response.data.errors || {});
        addToast(err.response.data.message || 'Validation failed. Please check your input.', 'error');
      } else {
        addToast(err.response?.data?.message || 'Failed to add testimonial. Please try again.', 'error');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 bg-gray-800 rounded-lg shadow-md text-text-white">
      <h1 className="text-3xl font-bold mb-6">Add New Testimonial</h1>
      {loading ? (
        <SkeletonLoader type="form" />
      ) : (
        <form onSubmit={handleSubmit}>
          <TextInput
            label="Client Name"
            name="name"
            id="name"
            value={formData.name}
            onChange={handleChange}
            required={true}
            placeholder="Client Name"
            error={validationErrors?.name?.[0]}
          />
          <TextInput
            label="Client Designation"
            name="client_designation"
            id="client_designation"
            value={formData.client_designation}
            onChange={handleChange}
            required={true}
            placeholder="Client Designation"
            error={validationErrors?.client_designation?.[0]}
          />
          <TextAreaInput
            label="Content"
            name="content"
            id="content"
            value={formData.content}
            onChange={handleChange}
            required={true}
            rows={4}
            placeholder="Content"
            error={validationErrors?.content?.[0]}
          />
          <FileInput
            label="Client Image"
            name="image"
            id="image"
            onChange={handleChange}
            error={validationErrors?.image?.[0]}
          />
          <CheckboxInput
            label="Active"
            name="is_active"
            id="is_active"
            checked={formData.is_active}
            onChange={handleChange}
          />
          <div className="flex items-center justify-between mt-6">
            <Button
              type="submit"
              className="bg-accent-red hover:bg-red-700 text-white"
              loading={loading}
            >
              Add Testimonial
            </Button>
            <Button
              type="button"
              onClick={() => navigate(ROUTES.TESTIMONIALS)}
              className="bg-gray-500 hover:bg-gray-600 text-white"
              disabled={loading}
            >
              Cancel
            </Button>
          </div>
        </form>
      )}
    </div>
  );
};

export default AddTestimonial;